import React from 'react'

import AdsConfig from '../../../config/sites/ads'
import { config } from '../../../common/config'

const CrossPromoBanner = ({ currentSite, currentCategory }) => {
  const currentSiteConfig = AdsConfig[currentSite]

  const matchedAdsFromConfig = config => {
    return config.reduce((incr, ad) => {
      if (Array.isArray(ad.match)) {
        ad.match.forEach(match => {
          if (match === currentCategory) {
            incr.push(ad)
          }
        })
      } else {
        if (ad.match === currentCategory) {
          incr.push(ad)
        }
      }
      return incr
    }, [])
  }

  const matchedAds = matchedAdsFromConfig(currentSiteConfig)

  if (matchedAds.length === 0) return null

  return (
    <div>
      <hr className="search-facet-divider" />
      {matchedAds.map(ad => {
        return (
          <div key={ad.title} className="cross-promos__box">
            <div className="cross-promos">
              {ad.icon_source && (
                <img
                  className="fds-u-mb2"
                  title={ad.title}
                  src={`${config.assets
                    .PUBLIC_PATH}/images/cross-promos/${ad.icon_source}`}
                  alt={ad.title}
                />
              )}

              <div className="cross-promos__header fds-u-m0">{ad.title}</div>

              <p
                dangerouslySetInnerHTML={{
                  __html: ad.content
                }}
                className="fds-c-text-body -size-s"
              />

              <a
                title={ad.button_label}
                className="fds-c-button--outline -color-primary -width-full"
                href={ad.link}
              >
                {ad.button_label}
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default CrossPromoBanner



// WEBPACK FOOTER //
// ./client/components/banners/crossPromoBanner.js